var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-countdown",attrs:{"title":_vm.timespan}},[(_vm.deadline)?_c('countdown',{attrs:{"deadline":_vm.deadline}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }